module.exports = __webpack_public_path__ + "static/media/ENDQUIZ.70cf0647.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ENDQUIZ.png
// module id = 191
// module chunks = 0